import { useAsyncOperation } from "./useAsyncOperation";
import { db } from "../Utilities/dexieConnections";

export function useDexieCrud(tableName) {
    const { isLoading, manageAsyncOperation } = useAsyncOperation();

    /** Save data to table
     * @param {any} data - Data to save
     * @param {any} key - Key for the data
     */
    function saveData(data, key) {
        return manageAsyncOperation(
            async () => {
                await db[tableName].add(data, [key]);
                return { error: false, data: "success" };
            },
            (err) => {
                return { error: true, data: err };
            },
        );
    }

    /** Get data by key
     * @param {any} key - Key to search for
     */
    function getData(key) {
        return manageAsyncOperation(
            async () => {
                const data = await db[tableName].get(key);
                return {
                    error: false,
                    data,
                };
            },
            (err) => {
                return { error: true, data: err };
            },
        );
    }

    /** Delete data by key
     * @param {any} key - Key to delete
     */
    async function deleteData(key) {
        return manageAsyncOperation(
            async () => {
                await db[tableName].delete(key);
                return { error: false, data: "success" };
            },
            (err) => {
                return { error: true, data: err };
            },
        );
    }

    /** Remove all data from table */
    async function removeAllData() {
        return manageAsyncOperation(
            async () => {
                await db[tableName].clear();
                return { error: false, data: "success" };
            },
            (err) => {
                return { error: true, data: err };
            },
        );
    }

    return {
        saveData,
        getData,
        deleteData,
        removeAllData,
        isLoading,
    };
}
